export default "__VITE_ASSET__RWhAZfFD__"